type PrivacyOverviewCardProps = {
  title: string
  description: string
  accountStatusLabel: string
  accountStatusValue: string
  privacyUpdatedAtLabel: string
  privacyUpdatedAtValue: string
  dataOwnerLabel: string
  dataOwnerValue: string
}

export const PrivacyOverviewCard = ({
  title,
  description,
  accountStatusLabel,
  accountStatusValue,
  privacyUpdatedAtLabel,
  privacyUpdatedAtValue,
  dataOwnerLabel,
  dataOwnerValue,
}: PrivacyOverviewCardProps) => (
  <section className="ca-card-shell ca-theme-transition rounded-3xl p-5">
    <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-(--color-text-muted)">{title}</h2>
    <p className="mt-1 text-sm text-(--color-text-secondary)">{description}</p>
    <dl className="mt-4 space-y-3 text-sm text-(--color-text-secondary)">
      <div className="flex items-center justify-between gap-4">
        <dt className="text-(--color-text-muted)">{accountStatusLabel}</dt>
        <dd className="font-semibold text-(--color-text-primary)">{accountStatusValue}</dd>
      </div>
      <div className="flex items-center justify-between gap-4">
        <dt className="text-(--color-text-muted)">{privacyUpdatedAtLabel}</dt>
        <dd className="font-semibold text-(--color-text-primary)">{privacyUpdatedAtValue}</dd>
      </div>
      <div className="flex items-center justify-between gap-4">
        <dt className="text-(--color-text-muted)">{dataOwnerLabel}</dt>
        <dd className="font-semibold text-(--color-text-primary)">{dataOwnerValue}</dd>
      </div>
    </dl>
  </section>
)
